// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__os1-h","Label":"Input_Label__2wLho","InputElement":"Input_InputElement__1pujY","Invalid":"Input_Invalid__1CLch"};